import { Link, createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { AuthLayout, isServerPage, safeRedirect } from '@/features/auth/auth-layout';
import { SignInForm } from '@/features/auth/forms';
import { meQuery } from '@/lib/queries';

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } =>
    typeof search.redirect === 'string' ? { redirect: search.redirect } : {},
  beforeLoad: async ({ context, search }) => {
    const me = await context.queryClient.ensureQueryData(meQuery);
    if (!me) return;
    const target = safeRedirect(search.redirect);
    // Server-rendered pages (an OAuth consent) are not routes: leave the app for them.
    if (isServerPage(target)) {
      window.location.assign(target);
      return;
    }
    throw redirect({ href: target });
  },
  component: LoginPage,
});

function LoginPage() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const target = safeRedirect(search.redirect);
  return (
    <AuthLayout
      title="Sign in to Regent"
      subtitle="Welcome back."
      footer={
        <>
          New here?{' '}
          <Link to="/signup" search={search} className="font-medium text-accent-text hover:underline">
            Create an account
          </Link>
        </>
      }
    >
      <SignInForm
        redirectTo={target}
        onDone={() =>
          isServerPage(target) ? window.location.assign(target) : void navigate({ href: target })
        }
      />
      <p className="mt-4 text-center text-sm">
        <Link to="/forgot-password" className="text-fg-muted hover:text-fg hover:underline">
          Forgot your password?
        </Link>
      </p>
    </AuthLayout>
  );
}
